import React from 'react'

export default function RefreshIconBlue() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
        <path d="M1.66362 3.24242C2.51627 1.90155 4.10518 1 5.92453 1C8.64427 1 10.8491 3.01472 10.8491 5.5C10.8491 7.98528 8.64427 10 5.92453 10C3.20479 10 1 7.98528 1 5.5" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.07782 3.25H1.61556V1" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
